import { render, staticRenderFns } from "./BrandedCard.vue?vue&type=template&id=968b55fa&"
import script from "./BrandedCard.vue?vue&type=script&lang=js&"
export * from "./BrandedCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports